<template>
	<toolbar-button
		v-if="selected"
		v-show="selected.length != 0"
		icon="mdi-folder-remove"
		tooltip="Delete folder"
		color="error"
		@click="onDeleteSelectedFolders"
		:button="{ disabled: selected.length < 1 }"
	></toolbar-button>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { PtModal } from 'plant-common';
import ToolbarButton from './ToolbarButton';
import {
	ACTION_DELETE_FOLDER,
	ACTION_REFRESH,
	STATE_FOLDER,
	STATE_SELECTED,
	STORE_EXPLORER_NAME
} from '@/store_constants/explorer';

export default {
	mixins: [PtModal],
	components: { ToolbarButton },
	computed: {
		...mapState(STORE_EXPLORER_NAME, {
			folder: STATE_FOLDER,
			selected: STATE_SELECTED
		})
	},
	methods: {
		...mapActions(STORE_EXPLORER_NAME, {
			deleteFolder: ACTION_DELETE_FOLDER,
			refresh: ACTION_REFRESH
		}),
		async deleteSelectedFolders(selectedFolders, actionDeleteFolder = this.deleteFolder) {
			let results = [];
			let promises = [];
			let errorMessages = [];
			selectedFolders.map(folder => {
				promises.push(
					actionDeleteFolder(folder)
						.then(response => {
							results.push({ folder, response });
						})
						.catch(error => {
							errorMessages.push(`${folder.name} ${error.response.data.message}`);
						})
				);
			});

			await Promise.all(promises);
			return errorMessages;
		},
		async onDeleteSelectedFolders() {
			const response = await this.deleteFolderModal();

			if (!response) return;

			const errorMessages = await this.deleteSelectedFolders(this.selected);

			if (errorMessages.length) {
				const message = errorMessages.join('. ');
				await this.$modal('info', { title: 'Not all folders were deleted.', message });
			}

			this.refresh();
		},
		async deleteFolderModal() {
			return await this.$modal('confirm', {
				title: `Are you sure you want to delete ${
					this.selected.length
				} selected folder${this.selected.length > 1 ? 's' : ''}?`,
				accept: {
					color: 'error',
					text: 'Delete',
					icon: 'mdi-delete'
				},
				cancel: { text: 'cancel', color: 'success' }
			});
		}
	}
};
</script>

<style></style>
